import { CreateQuestion } from "components/EmbeddedForm/CreateQuestion";
import { CreateReferral } from "components/EmbeddedForm/CreateReferral";
import { IframeContent } from "components/EmbeddedForm/IframeContent";
import { LoginDriver } from "components/EmbeddedForm/LoginDriver";
import { RecipientInfo } from "components/EmbeddedForm/RecipientInfo";
import { StartSelector } from "components/EmbeddedForm/StartSelector";
import { ErrorWindow } from "components/ErrorWindow";
import { Header } from "Dashboard.style";
import { formModes, loginStates, useEmbeddedForm } from "EmbeddedForm.hook";
import { ReactComponent as RSLogo } from "images/rs-logo.svg";
import * as FP from "utils/fp-js";

/** @type {import("types").NewPractice} */
export const defaultPractice = {
  practiceId: "",
  practiceName: "",
  practicePhone: "",
  street: "",
  street2: "",
  city: "",
  state: "",
  zipCode: "",
  speciality: "",
};
/** @type {import("types").NewSender} */
export const defaultSender = {
  senderId: "",
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  jobTitle: "",
};

export const EmbeddedForm = () => {
  const {
    formCode,
    loading,
    setLoading,
    error,
    setError,
    originator,
    reloadAuthData,
    hanldeLogout,
    providers,
    setProviders,
    recipient,
    locations,
    mode,
    setMode,
    isIframeEmbedded,
    loginState,
    setLoginState,
    codeError,
  } = useEmbeddedForm();

  if (isIframeEmbedded) {
    if (!codeError) {
      return <IframeContent formCode={formCode} />;
    }

    return null;
  }

  return (
    <div className="w-screen h-screen flex flex-col justify-between items-center pt-4">
      <Header>
        <RSLogo width={"103px"} />
      </Header>
      {!codeError && (
        <div className="w-fit h-full flex flex-col justify-center items-center px-4 pb-40">
          <LoginDriver
            originator={originator}
            loading={loading}
            setError={setError}
            setLoading={setLoading}
            reloadAuthData={reloadAuthData}
            state={loginState}
            setState={setLoginState}
            hanldeLogout={hanldeLogout}
          />
          {loginState === loginStates.INFO && (
            <>
              {FP.match(mode)
                .on(
                  formModes.START,
                  <>
                    <RecipientInfo recipient={recipient} />
                    <StartSelector
                      setMode={setMode}
                      originator={originator}
                      recipient={recipient}
                      loading={loading}
                    />
                  </>
                )
                .on(
                  formModes.ASK_QUESTION,
                  <CreateQuestion
                    formCode={formCode}
                    originator={originator}
                    providers={providers}
                    recipient={recipient}
                    locations={locations}
                    setMode={setMode}
                    loading={loading}
                    setError={setError}
                    setLoading={setLoading}
                    reloadAuthData={reloadAuthData}
                    handleLogout={hanldeLogout}
                    loginState={loginState}
                    setLoginState={setLoginState}
                    setProviders={setProviders}
                  />
                )
                .on(
                  formModes.CREATE_REFERRAL,
                  <CreateReferral
                    formCode={formCode}
                    originator={originator}
                    recipient={recipient}
                    locations={locations}
                    setMode={setMode}
                    loading={loading}
                    providers={providers}
                    setProviders={setProviders}
                    setError={setError}
                    setLoading={setLoading}
                    reloadAuthData={reloadAuthData}
                    loginState={loginState}
                    setLoginState={setLoginState}
                    hanldeLogout={hanldeLogout}
                  />
                )
                .otherwise(null)}
            </>
          )}
        </div>
      )}
      {error && <ErrorWindow error={error} handleClose={() => setError("")} />}
    </div>
  );
};
